import { IssueUsage } from './IssueUsage';
import { StockDetails } from '../../../store/api';

export enum ExtendedManageLineUsageLimit {
    Value = 'Value',
    None = 'None',
    NotRenewed = 'NotRenewed'
}

export type ExtendedManageLineShared = {
    currentYearSubscription: ExtendedManageLineUsageLimitValue | ExtendedManageLineUsageLimitNone;
    nextYearSubscription:
        | ExtendedManageLineUsageLimitValue
        | ExtendedManageLineUsageLimitNone
        | ExtendedManageLineUsageLimitNotRenewed;
    previousIssueUsage?: IssueUsage;
    currentIssueUsage?: IssueUsage;
};

export type ExtendedManageLineUsageLimitValue = {
    type: ExtendedManageLineUsageLimit.Value;
    label: string;
    stockDetails: StockDetails;
};
export type ExtendedManageLineUsageLimitNone = {
    type: ExtendedManageLineUsageLimit.None;
    label: string;
};
export type ExtendedManageLineUsageLimitNotRenewed = {
    type: ExtendedManageLineUsageLimit.NotRenewed;
    label: string;
};
